import React from 'react'
import { apiFetch } from '../../../fetchApi';

export const updateEducation = ({ BeURL, id, education, handleTopClear, candidateId, showAlert }) => {
    apiFetch(`${BeURL}/candidate-education/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ education, candidateId }),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                // setTimeout(()=>{
                //     window.location.reload()
                // },[500])
                handleTopClear()
                window.location.reload()

            } else {
                showAlert(data.message );
            }
        })
        .catch((err) => {
            console.log("Error in create Education", err);
        });
}
